import React, { useState, useEffect, useRef, useContext, } from 'react';
import { useToken } from '../../utilities/hooks';
import { useDispatch, useSelector, } from 'react-redux';
import { ValidatorForm, TextValidator, } from 'react-material-ui-form-validator';
import { useTranslation } from 'react-i18next';
import { openEditOrderModal, handleEditOrderModal, showAlertSnackbar, getEditOrderInit, handleOpenDestinationEditDialog } from '../../reducers/uiSlice';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Snackbar, Accordion, AccordionSummary, AccordionDetails,
    Table, TableBody, TableRow, TableCell,
    Badge, Grid, Card, CardContent, Link,
    CircularProgress, Backdrop, InputLabel, Button,
    IconButton, TextField, Typography, InputAdornment,
    Divider, Tooltip, Fab, Checkbox, Switch, Select, MenuItem,
} from '@material-ui/core';
import {
    Edit, AirportShuttle, Close, ExpandMore,
    History, Refresh, Search, TransferWithinAStation,
} from '@material-ui/icons';
import { green, blue } from '@material-ui/core/colors';
import Alert from '@material-ui/lab/Alert';
import momentTimeZone from "moment-timezone";
import moment from 'moment';
import _ from 'lodash';

import UniDialog from '../Common/UniDialog';
import OrderDetail from './Detail';
import HistoryDrawer from './HistoryDrawer';
import RouteTimeline from './RouteTimeline';
import FurtherOperation from './FurtherOperation';
import SecondaryDelivery from './SecondaryDelivery';
import DestinationEditForm from './DestinationEditForm';
import NextTransition from './NextTransition';
import CustomerFeedBack from './CustomerFeedBack';
import OperationTimeline from './OperationTimeline';
import AbnormalRecords from './AbnormalRecords';
import DriverDispatches from './DriverDispatches';
import TransshipmentOperation from './TransshipmentOperation';
import IncidentBox from './IncidentBox';
import { getBranchList, operationLog, } from '../../actions/commonAction';
import {
    getOrderInfo, updateOrderInfo, getBasicInfo, getOrderInfoDetail,
    editOrderAddress, openFieldChangeDialog, openDriverTransferDialog,
    openSecondaryDeliveryDialog, orderJumpInLineAddToRoute, getDriverScanRecord, switchRetry, orderJumpInLineTransferToDriver, orderJumpInLineTransferTest, getFailedReason, getCustomerComplainReason, createCustomerComplain, getCustomerComplain, updateSignatureRequiredInfo, deliveryOperation,
    updateFailedReason,
} from '../../actions/editOrderActions';
import { assignOrderToDriver, getExpirationProcessingType} from '../../actions/mmActions';
import { getLetianStaff, getLetianStaffTemp } from '../../actions/qtActions';
import { TokenContext } from '../../route/protectedRoute';

import { getLanguagePref } from '../../utilities/language';
import { getCurrentWarehouse, getUserPreference, stripIdFromStaffName, handleTextualizeDriverNameAndVehicleType, getBranchById, latLngVerify, regexZipMatch } from '../../utilities/common';
import FullscreenLoading from '../Common/FullscreenLoading';
import {string} from "prop-types";
import CorrectionModal from '../WrongAddressManagement/CorrectionModal';
import { batchCorrectServiceWrongAddress, getProvincesCovered } from '../../actions/wrongAddressActions';
import { getProvinceCountryByWarehouse } from '../../actions/driverAppApprovalActions';
import AddBoxIcon from '@material-ui/icons/AddBox';
import complaintReason from '../../constants/complaintReason.json';
import { getChargeReason, getPaymentCycle, viewPayroll } from '../../actions/payRollAdjustmentAction';
import PaymentAdjustmentDialog from '../PayrollAdjustment/PayRollTable/PaymentAdjustmentDialog';

const READ_ONLY = 300;
const INCIDENT_MANAGEMENT_ROLE=31;
const CLIENT_COMPLAINT_ROLE=14;
const EDIT_WEIGHT_SIZE=305;
const ENABLE_FAILED_REASON_MODIFY = 317;
const ENABLE_SIGNATURE_MODIFY = 318;

const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.paper,
        zIndex: theme.zIndex.modal - 1
      },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
      },
    button: {
        margin: theme.spacing(1),
        backgroundColor: blue[500],
    },
    searchFab: {
        width: 40,
        height: 40,
        marginLeft: 16,
    },
    iconButton: {
        marginTop: 30,
        width: 30,
        height: 30,
        marginRight: 20,
    },
    Edit: {
        color: green[500],
        fontSize: 20,
    },
    badgeWithoutContent: {
        transform: 'unset',
        right: 'unset'
    },
    orderSections: {
        marginBottom: theme.spacing(2)
    },
    labelTitle: {
        fontWeight: 'bold'
    },
    driverStyle: {
        marginTop: 20,
        padding: '10 5'
    },
    titleStyle: {
        marginBottom: 10
    },
    complainSection: {
        padding: 10,
        border: '1px grey solid',
        borderRadius: 10,
        marginBottom: 20
    },
    complainDetail: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 8
    }
}))

const MOBILE_PATTERN = "^[1]?[1-9]{1}[0-9]{9}$";
const ADDRESS_PATTERN = "^[A-Za-z0-9_]{1,100}$";
const UNIT_PATTERN = "^[A-Za-z0-9]{1,10}$";
const POSTCODE_PATTERN = "^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$";
const BUZZ_CODE_PATTERN = "^[A-Za-z0-9#*^%@!]{4,10}$";
const LATITUDE_PATTERN ="^(\\+|-)?(?:90(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,6})?))$";
const LONGITUDE_PATTERN ="^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$";
const DRIVER_MEMO_PATTERN = "^[\w\W]{1,2}$";
const ORDER_MEMO_PATTERN = "^[\s\S]*";


//const WAREHOUSE_PATTERN = "^[A-Za-z0-9]{1,10}$";
//const SHIPPING_STATUS_PATTERN = "^[A-Za-z0-9]{1,10}$";
const THIRD_PART_DELIVERY_SN_PATTERN = "^[A-Za-z0-9]{1,20}$";

const MOBILE_PATTERN_MSG = "Please input the phone number in North American format";
const ADDRESS_PATTERN_MSG = "invalid characters included, length: 1- 100";
const UNIT_PATTERN_MSG = "invalid characters included, length: 1- 10";
const POSTCODE_PATTERN_MSG = "Please input the post code match North America format";
const BUZZ_CODE_PATTERN_MSG = "length: 4- 10";
const LATITUDE_PATTERN_MSG = "Please input the latitude in correct format";
const LONGITUDE_PATTERN_MSG = "Please input the longitude in correct format";
const DRIVER_MEMO_PATTERN_MSG = "length should be less than 120";
const ORDER_MEMO_PATTERN_MSG = "length should be less than 120";
const THIRD_PART_DELIVERY_SN_PATTERN_MSG = "invalid characters included, length: 1- 20";

const CUSTOMER_SERVICE = "Customer Service";
const SENIOR_CUSTOMER_SERVICE = "Senior Customer Service";

const SEARCH_SN_HISTORY_SIZE = 10;

const SHIPPING_STATUS_LIST = [
    {name: 'Pending Delivery', value: 0},
    {name: 'Start Delivery', value: 1},
    {name: 'Finish Delivery', value: 2}
]
const UNIT_WEIGHT_LIST = [
    {key: 0, name: 'KGS', value: 'KGS'},
    {key: 1, name: 'LBS', value: 'LBS'}

]
const UNIT_SIZE_LIST = [
    {key: 0, name: 'CM', value: 'CM'},
    {key: 1, name: 'IN', value: 'IN'}

]

export default function EditOrderModal(props) {
  const classes = useStyles();
  const {t} = useTranslation('editOrder');
  const dispatch = useDispatch();
  const tokenContents = useToken();

  const userUS = tokenContents.userUS;
  const isUserReadOnly = tokenContents.uiAbilities.includes(READ_ONLY);
  const enableClientComplaint= tokenContents.uiAbilities.includes(CLIENT_COMPLAINT_ROLE);
  const enableIncidentManagement=  tokenContents.uiAbilities.includes(INCIDENT_MANAGEMENT_ROLE);
  const ableModifyWeightAndSize = tokenContents.uiAbilities.includes(EDIT_WEIGHT_SIZE);
  let userPref = getUserPreference();
    const disableFailedReason = !tokenContents.uiAbilities.includes(ENABLE_FAILED_REASON_MODIFY);
    const disableSignature = !tokenContents.uiAbilities.includes(ENABLE_SIGNATURE_MODIFY);

  const userInfo = useContext(TokenContext);

  const open = useSelector(openEditOrderModal);
  const editOrderInit = useSelector(getEditOrderInit);
    const complainReasonList = useSelector(state => state.editOrder.getCustomerComplainReason);
    const customerComplainList = useSelector(state => state.editOrder.getCustomerComplain);

    let operationPair = {
        'mobile': 'EDIT_MOBILE',
        'address': 'EDIT_ADDRESS',
        'unit': 'EDIT_UNIT',
        'postcode': 'EDIT_POSTCODE',
        'buzzCode': 'EDIT_BUZZCODE',
        'lat': 'EDIT_LAT',
        'lng': 'EDIT_LNG',
        'driverMemo': 'EDIT_DRIVER_MEMO',
        'orderMemo': 'EDIT_ORDER_MEMO',
        'warehouse': 'EDIT_WAREHOUSE',
        'thrdPrtDeliverySN': 'EDIT_THIRD_PARTY_SN',
        'shippingStatus': 'EDIT_SHIPPING_STATUS',
        'packageWeight': 'EDIT_ORDER_WEIGHT',
        'packageSize': 'EDIT_ORDER_SIZE'
    }

    const RETRY_SERVICE_DISABLED_STATUS_LIST = [231, 232];
    const MODIFY_WEIGHT_OR_SIZE_DISABLED_STATUS_LIST = [203, 207,215,216,217,218,224];
    const READ_ONLY_STATE_LIST = [220];

  const searchTypeList = useSelector(state => state.editOrder.searchTypeList);
  const orderInfo = useSelector(state => state.editOrder.orderInfo);
  const orderInfoDetail = useSelector(state => state.editOrder.orderInfoDetail);
  const scndryDeliveryInfo = useSelector(state => state.editOrder.scndryDeliveryInfo);
//   const warehouseList = useSelector(state => state.editOrder.warehouseList) || [];
  const warehouseList = useSelector(state => state.common.branches) || [];
  const exceptionList = useSelector(state => state.editOrder.exceptionList) || [];
  const isOrderLoading = useSelector(state => state.editOrder.orderLoading) || false;
  const createSecondDeliveryLoading = useSelector(state => state.editOrder.createSecondaryDeliveryLoading) || false;

  const isOrderUpdateLoading = useSelector(state => state.editOrder.orderUpdateLoading) || false;
  const isUpdateScanStatusLoading = useSelector(state => state.editOrder.updateScanStatusLoading) || false;
  const isUpdateShippingStatusLoading = useSelector(state => state.editOrder.updateShippingStatusLoading) || false;

  const getOpenFieldChangeDialog = useSelector(state => state.editOrder.openFieldChangeDialog);
  const getOpenDriverTransferDialog = useSelector(state => state.editOrder.openDriverTransferDialog);

    const failedReasonList = useSelector(state => state.editOrder.failedReasonList);

  const quickTransfer = useSelector(state => state.quickTransfer)

    const driverMemoScroll = useRef(null);

  const [byResendOrder, setByResendOrder] = useState(false);

  const [openSecondaryDeliveryDialog, setOpenSecondaryDeliveryDialog] = useState(false);
  const [openDestinationEditDialog, setOpenDestinationEditDialog] = useState(false);
  const [openReceiverEditDialog, setOpenReceiverEditDialog] = useState(false);

  const [currentFieldName,setCurrentFieldName] = useState();
  const [currentFieldValue,setCurrentFieldValue] = useState();
  const [searchType,setSearchType] = useState("tno");   //默认为Ant Parcel订单号；

  const [orderRouteHistoryList, setOrderRouteHistoryList] = useState([]);
  const [orderOperationHistoryList, setOrderOperationHistoryList] = useState([]);

  const [searchSN,setSearchSN] = useState("");
  const [isShowHistory,setIsShowHistory] = useState(false);
  const [historySearchSNList,setHistorySearchSNList] = useState([]);

  const [orderAccordionExpand, setOrderAccordionExpand] = useState(false);
  const [trackingAccordionExpand, setTrackingAccordionExpand] = useState(false);

  //used for order info
  const [storageInfo,setStorageInfo] = useState();
  const [callTime,setCallTime] = useState();
  const [smsTime,setSmsTime] = useState();
  const [contactTimes,setContactTimes] = useState();
  const [orderId,setOrderId] = useState();
  const [unitSN,setUnitSN] = useState();
  const [parcelSN,setParcelSN] = useState();
  const [batch,setBatch] = useState();
  const [linkedBatch,setLinkedBatch] = useState();
  const [itemDesc,setItemDesc] = useState();
  const [consignee,setConsignee] = useState();
  const [mobile,setMobile] = useState();
  const [address,setAddress] = useState();
  const [unit,setUnit] = useState();
  const [postcode,setPostcode] = useState();
  const [buzzCode,setBuzzCode] = useState();


  const [lat,setLat] = useState();
  const [lng,setLng] = useState();
  const [driver,setDriver] = useState();
  const [driverPhone,setDriverPhone] = useState();
  const [driverMemo,setDriverMemo] = useState();
  const [orderMemo,setOrderMemo] = useState();
  const [warehouse,setWarehouse] = useState();
  const [newLocation,setNewLocation] = useState();
  const [thrdPrtDeliverySN,setThrdPrtDeliverySN] = useState();
  const [scndryDlvryOrderSN,setScndryDlvryOrderSN] = useState();
  const [erroMsg,setErroMsg] = useState();
  const [resendSN,setResendSN] = useState();
  const [shippingStatus,setShippingStatus] = useState();
  const [packageWeight,setPackageWeight] = useState();
  const [packageWeightUnit,setPackageWeightUnit] = useState();
  const [packageHeight,setPackageHeight] = useState();
  const [packageWidth,setPackageWidth] = useState();
  const [packageLength,setPackageLength] = useState();
  const [packageSizeUnit,setPackageSizeUnit] = useState();
  //used for show order detail all
  const [isShowDetailAll,setIsShowDetailAll] = useState(false);

  //used for driver transfer
  const [driverTransfer,setDriverTransfer] = useState();
  const [isJumpInLine,setIsJumpInLine] = useState(0);

  //used for further operation judgement, if it's true then init the data
  const [isInit,setIsInit] = useState(true);

  // to prevent the contious post , once is submit , it need some time to resubmit
  const [isEditable,setIsEditable] = useState(false);
  const [isScndryDeliverySubmitted,setIsScndryDeliverySubmitted] = useState(false);

  const [orderRow, setOrderRow] = useState([]);
  const [destinationEditObj, setDestinationEditObj] = useState({});
  const [recordOrderUpdates, setRecordOrderUpdates] = useState([]);
  const [isOrderUpdated, setIsOrderUpdated] = useState(false);
  const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);

  const [searchSNCurr, setSearchSNCurr] = useState('');
  const [orderErr, setOrderErr] = useState('');

  const [transferDriverName, setTransferDriverName] = useState('...');
  const [driverExist, setDriverExist] = useState(false);

  const [transOpen, setTransOpen] = useState(false);

  const [branchList, setBranchList] = useState([]);

  const [sndDisabled, setSndDisabled] = useState(false);
  const [driverListTemp, setDriverListTemp] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [operationMemo, setOperationMemo] = useState('');

  const [driverDispatches, setDriverDispatches] = useState([]);

    const [openFailedReasonServiceDialog, setOpenFailedReasonServiceDialog] = useState(false);
    const [openSignatureServiceDialog, setOpenSignatureServiceDialog] = useState(false);
    const [failedReason, setFailedReason] = useState(0);
    const [failedReasonOrigin, setFailedReasonOrigin] = useState(0);
    const [signature, setSignature] = useState(false);
    const [signatureOrigin, setSignatureOrigin] = useState(false);
  const [openRetryServiceDialog, setOpenRetryServiceDialog] = useState(false);
  const [retrySwitchValue, setRetrySwitchValue] = useState(0);

  const [isOrderReadOnly, setIsOrderReadOnly] = useState(false);
  const [expirationProcessTypeList, setExpirationProcessTypeList] = useState([]);

  const [alertOpen, setAlertOpen] = useState(false);

  //payroll
  const [payrollDialogType, setPayrollDialogType] = useState('');
  const [openPayrollAdjustmentDialog, setOpenPayrollAdjustmentDialog] = useState(false);
  const [chargeReason, setChargeReason] = useState(null);
  const [timezone, setTimezone] = useState('');
  const [payrollDetail, setPayrollDetail] = useState([]);
  const [payrollFileDetail, setPayrollFileDetail] = useState([]);
  
  const [payRollList, setPayRollList] = useState([
    {
        id: 0,
        label: t('payment_cycle'),
        key: "payment_cycle",
        list: {},
        onlyManagerAccess: false,
        length: 4
    },
    {
        id: 1,
        label: t('status'),
        list: [
            {
                id: 0,
                text: t('new_entry'),
                value: 1
            },
            {
                id: 1,
                text: t('to_be_reviewed'),
                value: 2
            },
            {
                id: 2,
                text: t('approval'),
                value: 3
            }

        ],
        onlyManagerAccess: false,
        length: 2
    },
    {
        id: 2,
        label: t('deduction_subsidy'),
        list: [
            {
                id: 0,
                text: t('all'),
                value: -1
            },
            {
                id: 1,
                text: t('deduction'),
                value: 1
            },
            {
                id: 2,
                text: t('subsidy'),
                value: 2
            }

        ],
        onlyManagerAccess: false,
        length: 2
    },
    {
        id: 3,
        label: t('reason'),
        list: [],
        onlyManagerAccess: true,
        length: 3
    }
]);
    const handlePayrollDialogClose = () => {
        setIsFullScreenLoading(false)
        setOpenPayrollAdjustmentDialog(false)
        setPayrollDialogType()
    }

    const [openComplaintDialog, setOpenComplaintDialog] = useState(false);
    const [complaintContent, setComplaintContent] = useState('')
    const [freshdeskId, setFreshdeskId] = useState('');
    const [complaintNote, setComplaintNote] = useState('');

    useEffect(() => {
        setComplaintContent('');
        setFreshdeskId('');
        setComplaintNote('');
        setOperationMemo('');
    }, [openComplaintDialog])

  const displayCarrier = (id) => {
    switch (id) {
      case 1:
        return 'UniUni';
      case 2:
        return 'NB';
      default:
        return 'N/A';
    }
  };
  
  useEffect(() => {
    dispatch(getExpirationProcessingType())
      .then((res) => {
        setExpirationProcessTypeList(res);
      })
  }, []);

  const [openWrongAddressDialog, setOpenWrongAddressDialog] = useState(false);

  useEffect(() => {
    if(orderId) {
        dispatch(getDriverScanRecord(orderId))
        .then((res) => {
            setDriverDispatches(res);
        })
    }
  }, [orderId])

  //Only run this when open/close modal
  useEffect(() => {
    if(open) {
        init();
        setRecordOrderUpdates([]);
        dispatch(getBranchList())
        .then((res) => {
            setBranchList(res);
        })
        dispatch(getLetianStaff(userPref.userCity))
        .then((res) => {
            setSearchList(res);
        })
        if(userPref.userCity === 2) {
            dispatch(getLetianStaffTemp(14))
            .then((res) => {
                setDriverListTemp(res);
            })
        }
        if(userPref.userCity === 14) {
            dispatch(getLetianStaffTemp(2))
            .then((res) => {
                setDriverListTemp(res);
            })
        }
    } else {
        props.onClose(orderId, isOrderUpdated)
    }

    if(open && editOrderInit.orderIdentifier){
        dispatch(getOrderInfo(editOrderInit.orderIdentifier, editOrderInit.type))
    }
}, [open])

/**
 * Trim search input
 */
useEffect(() => {
    setSearchSN(searchSNCurr.replace(/\s/g, ""));
}, [searchSNCurr])

  /**
   * Show message of the secondary delivery serial SN
   */
  useEffect(() => {
    if (open === true && scndryDeliveryInfo !== undefined && scndryDeliveryInfo !== null) {
        if (scndryDeliveryInfo.order_sn !== undefined && scndryDeliveryInfo.order_sn !== null ) {
            dispatch(showAlertSnackbar({type: "info", title: "Create secondary delivery successfully, the new Order SN: " + scndryDeliveryInfo.order_sn}));
        }
    }
  },[scndryDeliveryInfo]);

  useEffect(() => {
    if(recordOrderUpdates.length > 0){
        dispatch(getOrderInfo(orderId, 'order_id'))
        setRecordOrderUpdates([])
        setIsOrderUpdated(true)
    }
  }, [recordOrderUpdates])



  //if the data according to the seach ID exist then assemble the data info and do some initial process
  useEffect(() => {
      if (open === true && orderInfo) {
        if (orderInfo.orders) {
            if(READ_ONLY_STATE_LIST.includes(orderInfo.orders.latest_status)) {
                setIsOrderReadOnly(true);
            } else {
                setIsOrderReadOnly(false);
            }
            let tracking = orderInfo.tracking || {}
            let callLog = orderInfo.calllog || {}
            let info = orderInfo.orders || {}
            let pathInfo = orderInfo.path || {}
            let incidentInfo = orderInfo.incidents || {}
            let exceptionString
            let exceptionObj = _.find(exceptionList, {id: tracking.exception})
            if(exceptionObj !== undefined){
                if(getLanguagePref().includes('en')) {
                    exceptionString = exceptionObj.en_message;
                } else {
                    exceptionString = exceptionObj.cn_message;
                }
            } else {
                exceptionString = `${tracking.exception || "N/A"}`
            }

// function that return the valid lat and lng info for the delivered pacakeg
            function DeliveryCoordinates() {
                let location = _.last(pathInfo.filter(pathInfo => pathInfo.code == 203 && pathInfo.staff_id != 666));
                if (location) {
                    if (location.scan_lng !== undefined && location.scan_lat !== undefined) {
                        return [
                            t('longitude') + ": " + location.scan_lng,
                            <br/>,
                            t('latitude') + ": " + location.scan_lat
                        ];
                    } else {
                        return "Undefined Coordinates";
                    }
                } else {
                    return "N/A"
                }
            }

            function packageSize() {
                return [
                    t('height') + ": " + (tracking?.height || "N/A ") + (tracking?.dimension_uom || ""),
                    <br/>,
                    t('width') + ": " + (tracking?.width || "N/A") + (tracking?.dimension_uom || ""),
                    <br/>,
                    t('length') + ": " + (tracking?.length || "N/A") + (tracking?.dimension_uom || ""),
                ];

            }

            function packageHoldingInfo() {
                return [
                    t('blocking_batch') + ": " + (tracking?.hold_info?.blocking_batch || "N/A "),
                    <br/>,
                    t('operator') + ": " + (tracking?.hold_info?.operator || "N/A"),
                    <br/>,
                    t('notes') + ": " + (tracking?.hold_info?.notes || "N/A"),
                ];

            }

            function convertWeighUnit(unit) {
                if (!_.isNil(unit)) {
                    let upperUnit = unit.toUpperCase();
                    if (upperUnit === "POUNDS" || upperUnit === "LBS" || upperUnit === "LB") {
                        return (tracking?.total_weight || "N/A ") + "LBS";
                    } else
                        return (tracking?.total_weight || "N/A ") + upperUnit;
                } else return "N/A "
            }

            function GetIncidentsNotes() {
                let notes = _.last(incidentInfo.notes)
                if (incidentInfo) {

                    return [
                        incidentInfo.map((incident) => (
                            <p>{incident.id}: {incident.notes}</p>
                        ))
                    ];

                } else {
                    return "N/A"
                }
            }

            function getFailedDeliveryActionName(value) {
                const matchingItem = _.find(expirationProcessTypeList, item => item.value === String(value));
                return matchingItem ? matchingItem.name : 'N/A';
              }

            setOrderRow([
                {name: t('driver_id'), data: `${info.shipping_staff_id} - ${stripIdFromStaffName(info.driver_name)}`, transfer: true},
                {name: t('driver_phone'), data: info.driver_phone},
                {name: t('driver_memo'), data: info.driver_notes, edit: 'driverMemo'},
                {name: t('order_memo'), data: info.postscript, edit: 'orderMemo'},
                {name: t('warehouse'), data: info.warehouse, edit: 'warehouse'},
                {name: t('failed_delivery_action'), data: getFailedDeliveryActionName(info.failed_delivery_action)},
                {name: t('new_location'), data: tracking.pathAddr},
                {name: t('third_part_delivery_SN'), data: tracking.shipper, edit: 'thrdPrtDeliverySN'},
                {name: t('secondary_delivery_order_SN'), data: tracking.second_delivery_sn},
                {name: t('error_message'), data: exceptionString},
                // {name: t('incident_notes'), data: GetIncidentsNotes()},
                {name: t('resend_SN'), data: tracking.resend_req_no},
                {name: t('shipping_status'), data: info.shipping_status, edit: 'shippingStatus'},
                {name: t('shipping_time'), data: info.shipping_time ? moment.unix(info.shipping_time).format("YYYY-MM-DD HH:mm:ss") : ''},
                {name: t('delivery_coordinates'),  data: DeliveryCoordinates()},
                {name: t('box_number'), data: tracking.bag_no},
                {name: t('total_weight'), data:  convertWeighUnit( tracking.weight_uom),editWeightOrSize: 'packageWeight'},
                {name: t('package_size'), data: packageSize() ,editWeightOrSize: 'packageSize'},
                {name: t('holding_info'), data: packageHoldingInfo()},


            ])
            assembleOrderDetail(orderInfo.orders);

            //save the search SN to local Storage
            saveSearchSNToLocal(orderInfo.orders);

            //get the basic info, warehouse
            dispatch(getBasicInfo());

            //enable the button statue
            setIsEditable(true);
            setIsScndryDeliverySubmitted(true);
            //setIsNextTransitionSubmitted(true);
            setOrderAccordionExpand(true)
        }

          if (orderInfo.tracking) {
            setSndDisabled(false);
            assembleOrderTracking(orderInfo.tracking);
            if(orderInfo.tracking.state !== 213) {
                setSndDisabled(true);
            }
        }

        if (orderInfo.calllog) {
            assembleOrderCallLog(orderInfo.calllog);
        }

        if (orderInfo.path) {
            setOrderRouteHistoryList(orderInfo.path);
            setTrackingAccordionExpand(true)
        }

        if (orderInfo.operation) {
            setOrderOperationHistoryList(orderInfo.operation);
        }

        setIsInit(false);

      } else {

        //disable the button statue
        setIsEditable(false);
        setIsScndryDeliverySubmitted(false);

        setIsInit(true);
      }
  },[orderInfo]);

    //get order details while click order tno in resend order page
    useEffect(() => {
        if(props.tno) {
            setSearchSN(props.tno);
        }
        if(props.tnoType) {
            setSearchType(props.tnoType);
        }
    }, [props.tno]);

    useEffect(() => {
        if(props.byResendOrder) {
            handleSearch();
        }
    }, [searchSN])

    useEffect(() => {
        setByResendOrder(props.byResendOrder);
    }, [props.byResendOrder])

    useEffect(() => {
        if(getOpenFieldChangeDialog && currentFieldName === "warehouse") {
            setCurrentFieldValue(warehouse);
        }
    }, [getOpenFieldChangeDialog])

    useEffect(() => {
        dispatch(getProvincesCovered(userUS ? 'US' : 'CA'));
        dispatch(getCustomerComplainReason());
        dispatch(getFailedReason());
        setFailedReason(0);
        setSignature(false);
    }, [])

    useEffect(() => {
        setFailedReasonOrigin(Number(orderInfo?.tracking?.failed_reason_type));
        setFailedReason(Number(orderInfo?.tracking?.failed_reason_type));
        setSignatureOrigin(displaySignature(orderInfo?.tracking?.dispatch_type));
        setSignature(displaySignature(orderInfo?.tracking?.dispatch_type));
    }, [orderInfo])

    useEffect(() => {
            const branchTimezone = getCurrentWarehouse();
        if (!_.isEmpty(branchTimezone)) {
            setTimezone(branchTimezone.time_zone)
        }
        dispatch(getPaymentCycle())
            .then((res) => {
                let arr = _.cloneDeep(payRollList);
                arr[0].list = res;
                setPayRollList(arr);
            })
            .catch(() => {
                setIsFullScreenLoading(false);
            })
            .finally(() => {
            })
        dispatch(getChargeReason())
            .then((res) => {
                setChargeReason(res);
            })
    }, []);

    const handleTransIdClick = (transId) => {
        setIsFullScreenLoading(true);
        setPayrollDialogType('review');
        dispatch(viewPayroll(transId))
            .then((res) => {
                if (_.isNil(res[0])) {
                    dispatch(showAlertSnackbar({ message: "No Data Found", type: 'error' }))
                } else {
                    setPayrollDetail(res[0]);
                    setPayrollFileDetail(res?.files);
                }
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({ message: err.message, type: 'error' }))
            })
            .finally(() => {
                setIsFullScreenLoading(false);
            })
        setOpenPayrollAdjustmentDialog(true)
    }

    return (
        <>
            <PaymentAdjustmentDialog
                chargeReason={chargeReason}
                payrollDialogType={payrollDialogType}
                handleDialogClose={handlePayrollDialogClose}
                open={openPayrollAdjustmentDialog}
                ableManagerAccess={true}
                isDataloading={isFullScreenLoading}
                payrollDetail={payrollDialogType === 'review' ? payrollDetail : []}
                payrollFileDetail={payrollDialogType === 'review' ? payrollFileDetail : []}
                handleMangerApprove={true}
                handleDeleteEntity={true}
                handleRefresh={true}
                handledataloading={true}
                statusList={payRollList[1]}
                timezone={timezone}
            />
            <Dialog
        onClose={handleClose}
        open={open || props.open}
        fullWidth={true}
        maxWidth='md'
        scroll='body'
    >
        <TransshipmentOperation
            orderId={orderId}
            transOpen={transOpen}
            handleTransClose={handleTransClose}
            onTransitionUpdate={()=>updateRecordOrderUpdates(true)}
        />
    <DialogTitle>
        {t('title_edit_order')}
        <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
            <Close onClick={handleClose}></Close>
        </Tooltip>
    </DialogTitle>
    <DialogContent dividers className={classes.root} >
        <ValidatorForm style={{display: 'flex', flex: 1, flexDirection: 'row' , marginTop: 16, marginBottom: 16, alignItems: 'center'}} onSubmit={handleSearch}>
            <div style={{display: 'flex', flex:1, flexDirection: 'row', marginRight: 16}}>
                <TextValidator
                    id="searchSN"
                    type="search"
                    label={t('searchNo')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={searchSNCurr}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                        )
                    }}
                    onKeyUp={(e)=>handleKeyUp(e)}
                    onChange={(e)=>{
                        setSearchSNCurr(e.target.value)
                    }}
                    validators={['required', 'matchRegexp:^[0-9A-Za-z" *"-]{0,40}$']}
                    errorMessages={['this field is required', 'only number and alphabet is allowed, could not start with 0 ,length could not be 0']}
                    style={{width: 400, marginRight: 16}}
                    autoFocus={true}
                />
                <TextField
                    id="searchType"
                    select
                    label={t('searchType')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={searchType}
                    onChange={(e)=>{
                        setSearchType(e.target.value)
                    }}
                    SelectProps={{
                        native: true,
                    }}
                    style={{flex: 1, maxWidth: 200}}
                >
                    {searchTypeList.map((item) => (
                        <option key={item.label} value={item.value}>
                        {item.label}
                        </option>
                    ))}
                </TextField>
            </div>
            <div style={{flexShrink: 2,flexDirection: 'row'}}>
                <Tooltip title={t('tip_search')} aria-label='search' >
                    <IconButton color='primary' onClick={handleSearch}>
                        <Search />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('tip_reset')} aria-label="reset" >
                    <IconButton color='primary' onClick={handleRest}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('tip_history')} aria-label="history">
                    <IconButton color='primary' onClick={e=>handleToggleDrawer(true,e)}>
                        <History />
                    </IconButton>
                </Tooltip>
            </div>
            <HistoryDrawer
                open={isShowHistory}
                toggleDrawer={toggleDrawer}
                historySearchSNList={historySearchSNList}
                handleHistorySearchSNChoose={handleHistorySearchSNChoose}>
            </HistoryDrawer>
        </ValidatorForm>
        <Divider />
        {isOrderLoading?
            <div style={{display: 'flex', height: 300}}>
                <CircularProgress color="primary" size={100} style={{margin: "auto"}}/>
            </div>
            :
            <>
                <form style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{flex: 4, marginBottom: 16}}>
                        <Accordion
                            defaultExpanded={orderInfo && orderInfo.orders}
                            disabled={!(orderInfo && orderInfo.orders)}
                            expanded={orderAccordionExpand}
                            onChange={()=>setOrderAccordionExpand(!orderAccordionExpand)}
                        >
                            <AccordionSummary
                                expandIcon={orderInfo && orderInfo.orders ? <ExpandMore />: null}
                            >
                                <Typography>{t('order_information')}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{width: '100%', flexDirection:'column'}}>
                                    <Card className={classes.orderSections}>
                                        <CardContent>
                                            <Typography variant='h6' style={{marginBottom: 16}}>{t('important_info')}
                                                （{orderInfo?.tracking &&
                                                    showPartnerName(
                                                        orderInfo?.orders?.partner_id,
                                                        orderInfo?.tracking?.internal_account_number,
                                                        orderInfo?.orders,
                                                    )})
                                            </Typography>
                                            <Grid container spacing={2}>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('storage_info')}: </span>
                                                        {(orderInfo.tracking && orderInfo.tracking.storage_info) || "N/A"}
                                                        {
                                                            (orderInfo.last_return_month ? '   ('+orderInfo.last_return_month+')' : "")
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('segment')}: </span>
                                                        {orderInfo.tracking && orderInfo.tracking.segment || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('call_time')}: </span>
                                                        {orderInfo.calllog && orderInfo.calllog.call_time !== null && orderInfo.calllog.call_time !== undefined ? moment.unix(orderInfo.calllog.call_time).format("YY-MM-DD hh:mm:ss") : "None"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('sms_time')}: </span>
                                                        {orderInfo.calllog && orderInfo.calllog.msg_time !== null && orderInfo.calllog.msg_time !== undefined ? moment.unix(orderInfo.calllog.msg_time).format("YY-MM-DD hh:mm:ss") : "None"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('calls')}: </span>
                                                        {orderInfo.calllog && orderInfo.calllog.retries || 0}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('order_type')}: </span>
                                                        {orderInfo?.orders && showOrderType(orderInfo?.orders?.type) }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('express_Type')}: </span>
                                                        {orderInfo?.tracking &&showExpressType( orderInfo?.tracking?.express_type)}
                                                    </Typography>
                                                </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography variant='body2' style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span
                                                                        className={classes.labelTitle}>{t('failed_reason')}:
                                                                    </span>
                                                                    <TextField
                                                                        select
                                                                        disabled={handleIsReadOnly() || disableFailedReason}
                                                                        value={failedReason}
                                                                        onChange={(e) => {
                                                                            setFailedReason(e.target.value);
                                                                            setOpenFailedReasonServiceDialog(true);
                                                                        }}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        style={{ marginLeft: 10 }}
                                                                    >
                                                                        <MenuItem value={0}>{t('initial')}</MenuItem>
                                                                        {
                                                                            failedReasonList?.length > 0 &&
                                                                            failedReasonList.map((reason) => (
                                                                                <MenuItem value={Number(reason.code)}>{reason.name}</MenuItem>
                                                                            ))
                                                                        }
                                                                    </TextField>
                                                    </Typography>
                                                </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography variant='body2' style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span
                                                                        className={classes.labelTitle}>{t('signature')}: </span>
                                                                    <TextField
                                                                        select
                                                                        disabled={handleIsReadOnly() || disableSignature}
                                                                        value={signature}
                                                                        onChange={(e) => {
                                                                            setSignature(e.target.value);
                                                                            setOpenSignatureServiceDialog(true);
                                                                        }}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        style={{ marginLeft: 10 }}
                                                                    >
                                                                        <MenuItem value={false}>{t('not_required')}</MenuItem>
                                                                        <MenuItem value={true}>{t('required')}</MenuItem>
                                                                    </TextField>
                                                    </Typography>
                                                </Grid>
                                                            <Grid item xs={5}>
                                                                <Typography variant='body2'>
                                                                    <span
                                                                        className={classes.labelTitle}>{t('transport_type')}: </span>
                                                                    {orderInfo?.orders && showTransportType(orderInfo?.orders?.transport_type)}
                                                                </Typography>
                                                            </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2'>
                                                        <span
                                                            className={classes.labelTitle}>{t('carrier')}: </span>
                                                        {orderInfo?.orders && displayCarrier(orderInfo?.orders?.carrier_id)}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('trans_id')}: </span>
                                                        {orderInfo?.orders?.trans_id
                                                            ? <Link href="#" onClick={() => {handleTransIdClick(orderInfo.orders.trans_id)}}>
                                                                {orderInfo.orders.trans_id}
                                                            </Link>
                                                            : 'N/A'
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography variant='body2'>
                                                        <span
                                                            className={classes.labelTitle}>{t('time_from_199')}: </span>
                                                        {displayTimeFrom199(orderInfo.path)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                    <Card className={classes.orderSections}>
                                        <CardContent>
                                            <Typography variant='h6' style={{marginBottom: 16}}>{t('batch_info')}</Typography>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('order_id')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.order_id || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('order_sn')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.order_sn || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('parcel_id')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.tno || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('batch')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.referer || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('linked_batch')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.pin_label || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('original_tno')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.original_tno || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('sub_batch')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.sub_referer || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('sender_refer')}: </span>
                                                        {orderInfo?.tracking && orderInfo?.tracking?.internal_account_number || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('item_description')}: </span>
                                                        {orderInfo.tracking && orderInfo.tracking.item_description || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant='body2' >
                                                        <span className={classes.labelTitle}>{t('partner')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.partner || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant='body2' style={{display:'flex',alignItems:'center'}}>
                                                        <span className={classes.labelTitle}>{t('retry_service')}: </span>
                                                        <TextField
                                                            select
                                                            disabled={RETRY_SERVICE_DISABLED_STATUS_LIST.includes(orderInfo?.tracking?.state) || handleIsReadOnly()}
                                                            value={orderInfo?.tracking?.enable_retry || 0}
                                                            onChange={(e)=>{
                                                                setRetrySwitchValue(e.target.value);
                                                                setOpenRetryServiceDialog(true);
                                                            }}
                                                            variant="outlined"
                                                            size="small"
                                                            style={{marginLeft:10}}
                                                        >
                                                            <MenuItem value={0} disabled>{t('initial')}</MenuItem>
                                                            <MenuItem value={-1}>{t('close')}</MenuItem>
                                                            <MenuItem value={1}>{t('open')}</MenuItem>
                                                        </TextField>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                    <Card className={classes.orderSections}>
                                        <CardContent>
                                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                <Typography variant='h6' style={{marginBottom: 16}}>Contact Info</Typography>
                                                {
                                                    handleIsReadOnly() ?
                                                        null
                                                        :
                                                        <IconButton
                                                            color='primary'
                                                            onClick={()=>setOpenReceiverEditDialog(true)}
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                }
                                            </div>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('consignee')}: </span>
                                                        {orderInfo.tracking && orderInfo.tracking.consignee || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('phone')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.mobile || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('extension_number')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.phone_extra || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('email')}: </span>
                                                        {orderInfo?.orders && orderInfo?.orders?.email || "N/A"}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                    <Card className={classes.orderSections}>
                                        <CardContent>
                                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                <Typography variant='h6' style={{marginBottom: 16}}>Destination Info</Typography>
                                                {
                                                    handleIsReadOnly() ?
                                                        null
                                                        :
                                                        <IconButton
                                                            id="editorder-destination-wrongaddressopen-button"
                                                            color='primary'
                                                                  onClick={() =>
                                                                      (!userUS && process.env.REACT_APP_WRONG_ADDRESS_FLAG) ?
                                                                          setOpenWrongAddressDialog(true)
                                                                          :
                                                                          setOpenDestinationEditDialog(true)
                                                            }
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                }
                                            </div>
                                            <Grid container spacing={2}>
                                                      <Grid item xs={10}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('address')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.address || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                      <Grid item xs={2}>
                                                    <Typography variant='body2'>
                                                              <Button
                                                                  onClick={handleCopy}
                                                              >
                                                                  {t('common:copy')}
                                                              </Button>
                                                    </Typography>
                                                </Grid>
                                                      <Grid item xs={4}>
                                                          <Typography variant='body2'>
                                                              <span className={classes.labelTitle}>{t('unit')}: </span>
                                                              {orderInfo.orders && orderInfo.orders.sign_building || "N/A"}
                                                          </Typography>
                                                      </Grid>
                                                      <Grid item xs={4}>
                                                          <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('post_code')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.zipcode || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('is_covered')}: </span>
                                                        {orderInfo?.zipCodeInfo && orderInfo?.zipCodeInfo?.isZipCovered?.toString() || "N/A"}
                                                    </Typography>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('is_blocked')}: </span>
                                                        {orderInfo?.zipCodeInfo && orderInfo?.zipCodeInfo?.isBlocked?.toString() || "N/A"}
                                                    </Typography>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('block_date')}: </span>
                                                        {orderInfo?.zipCodeInfo && orderInfo?.zipCodeInfo?.blockDate || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('buzz_code')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.buzz_code || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('latitude')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.lat || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'>
                                                        <span className={classes.labelTitle}>{t('longitude')}: </span>
                                                        {orderInfo.orders && orderInfo.orders.lng || "N/A"}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                          <Typography variant='h6' style={{ marginBottom: 16 }} ref={driverMemoScroll}>{t('other_info')}</Typography>
                                    <Table>
                                        <TableBody>
                                            {orderRow.map((row, index)=>{
                                                if(row.name === t('secondary_delivery_order_SN')) {
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell component="th" scope="row">{row.name}</TableCell>
                                                            <TableCell
                                                                align='left'
                                                                onClick={
                                                                    () => handleOpenEditOrder(row.data)
                                                                }
                                                                style={{
                                                                    cursor:'pointer'
                                                                }}
                                                            >
                                                                {row.data}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                } else {
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell component="th" scope="row">{row.name}</TableCell>
                                                            <TableCell align='left'>{row.data}</TableCell>
                                                            <TableCell align='right'>
                                                                {
                                                                    (row.edit && !handleIsReadOnly()) ?
                                                                        <IconButton
                                                                            color='primary'
                                                                            size='small'
                                                                            disabled={!isEditable}
                                                                            onClick={(e)=>handleFieldChange(e,row.edit)}
                                                                        >
                                                                            <Edit fontSize='inherit'/>
                                                                        </IconButton>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    (row.editWeightOrSize && ableModifyWeightAndSize &&
                                                                    !handleIsReadOnly()) ?
                                                                        <IconButton
                                                                            color='primary'
                                                                            size='small'
                                                                            disabled={MODIFY_WEIGHT_OR_SIZE_DISABLED_STATUS_LIST.includes(orderInfo?.tracking?.state)||!isEditable}
                                                                            onClick={(e)=>handleFieldChange(e,row.editWeightOrSize)}
                                                                        >
                                                                            <Edit fontSize='inherit'/>
                                                                        </IconButton>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    (row.transfer && !handleIsReadOnly()) ?
                                                                        <IconButton
                                                                            color='primary'
                                                                            size='small'
                                                                            disabled={!isEditable}
                                                                            onClick={handleDriverTransfer}
                                                                        >
                                                                            <TransferWithinAStation fontSize='inherit'/>
                                                                        </IconButton>
                                                                        :
                                                                        null
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    <Divider orientation="vertical" flexItem />
                    <div style={{flex:2, marginBottom: 16}}>
                        <Accordion
                            defaultExpanded={orderInfo && orderInfo.path && orderInfo.path.length > 0}
                            disabled={!(orderInfo && orderInfo.path && orderInfo.path.length > 0)}
                            expanded={trackingAccordionExpand}
                            onChange={()=>setTrackingAccordionExpand(!trackingAccordionExpand)}
                        >
                            <AccordionSummary
                                expandIcon={orderInfo && orderInfo.path && orderInfo.path.length > 0 ? <ExpandMore />: null}
                            >
                                <Typography>{t('tracking_log')}</Typography>
                                &nbsp;
                                <Badge
                                    color='error'
                                    badgeContent={orderInfo.path ? orderInfo.path.length: 0}
                                    max={99}
                                    classes={{anchorOriginTopRightRectangle: classes.badgeWithoutContent}}
                                />
                            </AccordionSummary>
                            <AccordionDetails>
                                <RouteTimeline orderRouteHistoryList={orderInfo.path}
                                               orderTrackingInfo={orderInfo.tracking}
                                                orderBasicInfo={orderInfo.orders}></RouteTimeline>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            defaultExpanded={false}
                            disabled={!(orderInfo && orderInfo.operation && orderInfo.operation.length > 0)}
                        >
                            <AccordionSummary
                                expandIcon={orderInfo && orderInfo.operation && orderInfo.operation.length > 0 ? <ExpandMore />: null}
                            >
                                <Typography>{t('edit_log')}</Typography>
                                &nbsp;
                                <Badge
                                    color='error'
                                    badgeContent={orderInfo.operation ? orderInfo.operation.length: 0}
                                    max={99}
                                    classes={{anchorOriginTopRightRectangle: classes.badgeWithoutContent}}
                                />
                            </AccordionSummary>
                            <AccordionDetails>
                                <OperationTimeline
                                    orderOperationHistoryList={orderInfo.operation}>
                                </OperationTimeline>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded={false}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                            >
                                <Typography>{t('driver_dispatch_record')}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                               <DriverDispatches
                                    driverDispatches={driverDispatches}
                               />
                            </AccordionDetails>
                        </Accordion>

                        {
                            handleIsReadOnly() ?
                                null
                                :
                                <>
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                    >
                                        <Typography>{t('operation')}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <NextTransition
                                            orderInfo={orderInfo || []}
                                            onTransitionUpdate={()=>updateRecordOrderUpdates(true)}
                                            handleTransClose={handleTransClose}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                    >
                                        <Typography>{t('order_abnormal_record')}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <AbnormalRecords
                                            orderInfo={orderInfo || []}
                                    />
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                    >
                                        <Typography>{t('reschedule_delivery')}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Button
                                            variant="contained"
                                            color='secondary'
                                            fullWidth
                                            startIcon={<AirportShuttle />}
                                            disabled={!isScndryDeliverySubmitted || sndDisabled}
                                            onClick={()=>setOpenSecondaryDeliveryDialog(true)}
                                        >
                                            {t('button_re_delivery')}
                                        </Button>
                                    </AccordionDetails>
                                </Accordion>
                                </>
                        }

                        { 
                            enableClientComplaint ?
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore/>}
                                    >
                                        <Typography>{t('title_customer_complain')}</Typography>
                                                  &nbsp;
                                              <Badge
                                                  color='error'
                                                      badgeContent={customerComplainList?.length || 0}
                                                  max={99}
                                                  classes={{ anchorOriginTopRightRectangle: classes.badgeWithoutContent }}
                                              />
                                    </AccordionSummary>
                                              <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
                                                  <div style={{ maxHeight: 400, overflow: 'scroll', marginBottom: 20 }}>
                                                      {
                                                          customerComplainList?.length > 0 && customerComplainList?.map((complain) => (
                                                              <div className={classes.complainSection}>
                                                                  <div className={classes.complainDetail}>
                                                                      <span style={{ marginRight: 5 }}>{t('complain_reason')}</span>
                                                                      <span>{complainToText(complain.complain_reason_id).reason || ''}</span>
                                                                  </div>
                                                                  <div className={classes.complainDetail
                                                                  }>
                                                                      <div style={{ marginRight: 5 }}>{t('freshdesk_id_symbol')}</div>
                                                                      <span>{complain.fresh_desk_ticket || ''}</span>
                                                                  </div>
                                                                  <div className={classes.complainDetail}>
                                                                      <span style={{ marginRight: 5 }}>{t('complain_note')}</span>
                                                                      <span>{complain.notes || ''}</span>
                                                                  </div>
                                                                  <div className={classes.complainDetail}>
                                                                      <span style={{ marginRight: 5 }}>{t('record_date') || ''}</span>
                                                                      <span>{moment.unix(complain.create_time).format("MMM DD, YYYY - HH:mm:ss") || ''}</span>
                                                                  </div>
                                                              </div>
                                                          ))
                                                      }
                                                  </div>
                                                  <div>
                                                      <Button
                                                          variant="contained"
                                                          color='secondary'
                                                          fullWidth
                                                          startIcon={<AddBoxIcon />}
                                                          onClick={() => setOpenComplaintDialog(true)}
                                                          disabled={!isEditable}
                                                      >
                                                          {t('new_complain')}
                                                      </Button>
                                                  </div>
                                    </AccordionDetails>
                                </Accordion>
                                :
                                null
                        }
                        
                        { 
                            enableClientComplaint ?
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                    >
                                        <Typography>{t('incident_management')}</Typography>
                                        &nbsp;
                                        <Badge
                                            color='error'
                                            badgeContent={orderInfo.incidents ? orderInfo.incidents.length: 0}
                                            max={99}
                                            classes={{anchorOriginTopRightRectangle: classes.badgeWithoutContent}}
                                        />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <IncidentBox
                                            incidentList={orderInfo.incidents || []}
                                            disabled={isEditable}
                                            trackingNumber = {orderInfo?.orders?.tno}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                                :
                                null
                        }
                    </div>
                </form>
                <Divider />
                <FurtherOperation orderInfo={isInit? [] : orderInfo} ></FurtherOperation>
                <CorrectionModal
                    open={openWrongAddressDialog}
                    onClose={()=>setOpenWrongAddressDialog(false)}
                    type={'batch'}
                    data={{
                        address: orderInfo?.orders?.address,
                        postal_code: orderInfo?.orders?.zipcode,
                        unit_no: orderInfo?.orders?.sign_building,
                        buzz_code: orderInfo?.orders?.buzz_code,
                        lat: orderInfo?.orders?.lat,
                        lng: orderInfo?.orders?.lng,
                        country: userUS ? 'US' : 'CA'
                    }}
                    handleUpdateClose={handleUpdateCloseSingle}
                    isEditOrder={true}
                />
            </>

        }
              <UniDialog
                  maxWidth='sm'
                  fullWidth
                  title={t('dialog_new_complain_title')}
                  open={openComplaintDialog}
                  onClose={() => {
                      setOpenComplaintDialog(false);
                      setOperationMemo('');
                  }}
                  disableDefaultButtons
                  buttons={[
                      {
                          color: 'primary',
                          text: t('create'),
                          action: () => {
                              handleSaveNewComplain();
                          },
                          id: 'editorder-newcomplaint-button',
                          disabled: !complaintContent
                      }
                  ]}
              >
                  <Grid container spacing={3}>
                      <Grid item xs={6}>
                          <TextField
                              variant='outlined'
                              fullWidth
                              select
                              label={t('complain_reason_star')}
                              value={complaintContent}
                              onChange={(e) => setComplaintContent(e.target.value)}
                          >
                              {
                                  complainReasonList?.length > 0 &&
                                      complainReasonList?.map((reason) => (
                                          <MenuItem value={reason.id}>{t(reason.reason)}</MenuItem>
                                  ))
                              }
                          </TextField>
                      </Grid>
                      <Grid item xs={6}>
                          <TextField
                              variant='outlined'
                              fullWidth
                              label={t('freshdesk_id')}
                              value={freshdeskId}
                              onChange={(e) => setFreshdeskId(e.target.value)}
                          />
                      </Grid>
                      <Grid item xs={12}>
                          <TextField
                              variant='outlined'
                              fullWidth
                              label={t('complaint_note')}
                              value={complaintNote}
                              onChange={(e) => setComplaintNote(e.target.value)}
                              multiline
                              rows={5}
                          />
                      </Grid>
                      <Grid item xs={12}>
                          <TextField
                              fullWidth
                              multiline
                              rows={3}
                              variant="outlined"
                              label={t('note')}
                              value={operationMemo}
                              onChange={(e) => { setOperationMemo(e.target.value) }}
                          />
                      </Grid>
                  </Grid>
              </UniDialog>
        <ValidatorForm onSubmit={handleEditFieldSubmit}>
        <UniDialog
            title={t('dialog_change_title')}
            open={getOpenFieldChangeDialog}
            onClose={() => {
                handleCloseFieldChangeDialog();
                setOperationMemo('');
            }}
            onFinish={handleSaveFieldChangeDialog}
        >
            { (currentFieldName === "mobile") ?
            <TextValidator
                autoFocus
                label="Consignee Mobile"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${MOBILE_PATTERN}`]}
                errorMessages={['this field is required', `${MOBILE_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "address") ?
            <TextValidator
                autoFocus
                label={t('consignee_address')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${ADDRESS_PATTERN}`]}
                errorMessages={['this field is required', `${ADDRESS_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "unit") ?
            <TextValidator
                autoFocus
                label={t('unit')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${UNIT_PATTERN}`]}
                errorMessages={['this field is required', `${UNIT_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "postcode") ?
            <TextValidator
                autoFocus
                label={t('post_code')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${POSTCODE_PATTERN}`]}
                errorMessages={['this field is required', `${POSTCODE_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "buzzCode") ?
            <TextValidator
                autoFocus
                label={t('buzz_code')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${BUZZ_CODE_PATTERN}`]}
                errorMessages={['this field is required', `${BUZZ_CODE_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "lat") ?
            <TextValidator
                autoFocus
                label={t('latitude')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${LATITUDE_PATTERN}`]}
                errorMessages={['this field is required', `${LATITUDE_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "lng") ?
            <TextValidator
                autoFocus
                label={t('lngtitude')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${LONGITUDE_PATTERN}`]}
                errorMessages={['this field is required', `${LONGITUDE_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "driverMemo") ?
            <TextValidator
                autoFocus
                label={t('driver_memo')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${DRIVER_MEMO_PATTERN}`]}
                errorMessages={['this field is required', `${DRIVER_MEMO_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "orderMemo") ?
            <TextValidator
                autoFocus
                label={t('order_memo')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${ORDER_MEMO_PATTERN}`]}
                errorMessages={['this field is required', `${ORDER_MEMO_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "warehouse") ?
            <TextValidator
                select
                autoFocus
                label={t('warehouse')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
            >
            {warehouseList.map((item) => (
                <option key={item.name} value={item.id}>
                {item.name}
                </option>
            ))}
            </TextValidator>
            : null
            }
            { (currentFieldName === "thrdPrtDeliverySN") ?
            <TextValidator
                autoFocus
                label={t('third_part_delivery_SN')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                value={currentFieldValue}
                validators={['required', `matchRegexp:${THIRD_PART_DELIVERY_SN_PATTERN}`]}
                errorMessages={['this field is required', `${THIRD_PART_DELIVERY_SN_PATTERN_MSG}`]}
            />
            : null
            }
            { (currentFieldName === "shippingStatus") ?
            <TextValidator
                autoFocus
                label={t('shipping_status')}
                select
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(e) => setCurrentFieldValue(e.target.value)}
                defaultValue=""
            >
                <option value="">
                    Select Delivery Status
                </option>
                {SHIPPING_STATUS_LIST.map((item)=>(
                    <option key={item.name} value={item.value}>
                        {item.name}
                    </option>
                ))}
            </TextValidator>
            : null
            }
            {
                (currentFieldName === "packageWeight") ?
                <TextValidator
                    autoFocus
                    label={t('total_weight')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setCurrentFieldValue(e.target.value)}
                    value={currentFieldValue}
                    validators={['required']}
                    errorMessages={['this field is required']}
                    style={{display: 'flex', paddingBottom: 10}}
                />
                : null
            }
            { (currentFieldName === "packageWeight") ?
                <TextValidator
                    autoFocus
                    label={t('unit')}
                    select
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setPackageWeightUnit(e.target.value)}
                    defaultValue=""
                    value={packageWeightUnit}
                    validators={['required']}
                    errorMessages={['this field is required']}
                >

                    {UNIT_WEIGHT_LIST.map((item)=>(
                        <option key={item.key} value={item.value}>
                            {item.name}
                        </option>
                    ))}
                </TextValidator>
                : null
            }

            { (currentFieldName === "packageSize" ) ?
                <TextValidator
                    autoFocus
                    label={t('height')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setPackageHeight(e.target.value)}
                    value={packageHeight}
                    validators={['required']}
                    errorMessages={['this field is required']}
                    style={{display: 'flex', paddingBottom: 10}}
                />
                : null
            }
            {
                (currentFieldName === "packageSize") ?
                    <TextValidator
                        autoFocus
                        label={t('width')}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        onChange={(e) => setPackageWidth(e.target.value)}
                        value={packageWidth}
                        validators={['required', ]}
                        errorMessages={['this field is required', `${DRIVER_MEMO_PATTERN_MSG}`]}
                        style={{display: 'flex', paddingBottom: 10}}
                    />
                    : null

            }
            {
                (currentFieldName === "packageSize") ?
                    <TextValidator
                        autoFocus
                        label={t('length')}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        onChange={(e) => setPackageLength(e.target.value)}
                        value={packageLength}
                        validators={['required']}
                        errorMessages={['this field is required']}
                        style={{display: 'flex', paddingBottom: 10}}
                    />
                    : null
            }
            { (currentFieldName === "packageSize") ?
                <TextValidator
                    autoFocus
                    label={t('unit')}
                    select
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setPackageSizeUnit(e.target.value)}
                    defaultValue=""
                    value={packageSizeUnit}
                    validators={['required']}
                    errorMessages={['this field is required']}
                >

                    {UNIT_SIZE_LIST.map((item)=>(
                        <option key={item.key} value={item.value}>
                            {item.name}
                        </option>
                    ))}
                </TextValidator>
                : null
            }
            <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{marginTop: 20}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
        </UniDialog >
        </ValidatorForm>
        <UniDialog
            title={t('dialog_transfer_title')}
            message={t('dialog_transfer_messgae')}
            open={getOpenDriverTransferDialog}
            onClose={() => {
                handleCloseDriverTransferDialog();
                setOperationMemo('');
            }}
            onFinish={handleSubmitDriverTransferDialog}
            buttonDisabled={!transferDriverName || !driverTransfer || transferDriverName === '...'}
        >
            <div className={classes.driverStyle}>
                <div style={{ marginBottom: 20 }}>
                    <span style={{ marginLeft: 10 }}>{transferDriverName}</span>
                </div>
                <TextField
                    autoFocus
                    label={t('driver_transfer')}
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    value={driverTransfer}
                    onChange={(e)=> {
                        setTransferDriverName(handleTextualizeDriverNameAndVehicleType(e.target.value, userPref.userCity, driverListTemp, searchList));
                        setDriverTransfer(e.target.value);
                    }}
                    style={{paddingBottom: 16}}
                />
            </div>
            <Checkbox
                checked={isJumpInLine}
                onChange={(e)=> setIsJumpInLine(e.target.checked)}
            />
            Jump in Line
            <InputLabel style={{color: 'red'}}>
            如果选【插单】<br></br>
            则该订单的路线编号会复制离它最近一单的路线编号<br></br>
            原路线编号会被覆盖且无法恢复<br></br>
            请谨慎操作!
            </InputLabel>
            <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{marginTop: 20}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
        </UniDialog>
        <UniDialog
                        title={t('dialog_failed_reason_title')}
                        message={t('dialog_failed_reason_message')}
                        open={openFailedReasonServiceDialog}
                        onClose={() => {
                            setOpenFailedReasonServiceDialog(false);
                            setOperationMemo('');
                            if (failedReason) {
                                setFailedReason(failedReasonOrigin);
                            }
                        }}
                        onFinish={handleFailedReasonSwitchValue}
                    >
                        <TextField
                            fullWidth
                            multiline
                            rows={2}
                            variant="outlined"
                            label={t('note')}
                            InputLabelProps={{ shrink: true }}
                            style={{ marginTop: 20 }}
                            value={operationMemo}
                            onChange={(e) => { setOperationMemo(e.target.value) }}
                        />
                    </UniDialog>
                    <UniDialog
                        title={t('dialog_signature_title')}
                        message={t('dialog_signature_message')}
                        open={openSignatureServiceDialog}
                        onClose={() => {
                            setOpenSignatureServiceDialog(false);
                            setOperationMemo('');
                            if (signature) {
                                setSignature(signatureOrigin);
                            }
                        }}
                        onFinish={handleSignatureSwitchValue}
                    >
                        <TextField
                            fullWidth
                            multiline
                            rows={2}
                            variant="outlined"
                            label={t('note')}
                            InputLabelProps={{ shrink: true }}
                            style={{ marginTop: 20 }}
                            value={operationMemo}
                            onChange={(e) => { setOperationMemo(e.target.value) }}
                        />
                    </UniDialog>
                    <UniDialog
            title={t('dialog_retry_title')}
            message={t('dialog_retry_messgae')}
            open={openRetryServiceDialog}
            onClose={() => {
                setOpenRetryServiceDialog(false);
                setOperationMemo('');
            }}
            onFinish={handleRetrySwitchValue}
        >
            <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{marginTop: 20}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
        </UniDialog>
        <UniDialog
            title="Receiver Edit"
            open={openReceiverEditDialog}
            onClose={()=>{
                setOpenReceiverEditDialog(false)
                setDestinationEditObj({})
                setOperationMemo('');
            }}
            onFinish={()=>{
                handleDestinationEditSubmit()
                setDestinationEditObj({})
            }}
        >
            <DestinationEditForm
                trackingInfo={orderInfo.tracking || undefined}
                order={orderInfo.orders || undefined}
                onInputChange={(obj)=>setDestinationEditObj(obj)}
                addressDisable={true}
            />
            <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{marginTop: 20}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
        </UniDialog>
        <UniDialog
            title="Address Edit"
            open={openDestinationEditDialog}
            onClose={()=>{
                setOpenDestinationEditDialog(false)
                setDestinationEditObj({})
                setOperationMemo('');
            }}
            onFinish={()=>{
                handleDestinationEditSubmit()
                setDestinationEditObj({})
            }}
        >
            <DestinationEditForm
                trackingInfo={orderInfo.tracking || undefined}
                order={orderInfo.orders || undefined}
                onInputChange={(obj)=>setDestinationEditObj(obj)}
                addressDisable={false}
            />
            <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{marginTop: 20}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
        </UniDialog>
        {
            openSecondaryDeliveryDialog
            ?
            <SecondaryDelivery handleClose={handleCloseSecondaryDeliveryDialog} orderInfo={orderInfo}></SecondaryDelivery>
            :
            null
        }
        <UniDialog 
            open={alertOpen}
            title={t('holding_info')}
            fullWidth
            onClose={() => {
                setAlertOpen(false);
            }}
            disableDefaultButtons
            disableBackdropClick={true}
            autoClose={false}
        >
            <div style={{marginBottom: 20}}>{t('blocking_batch')}: {orderInfo?.tracking?.hold_info?.blocking_batch || 'N/A' }</div>
            <div style={{marginBottom: 20}}>{t('operator')}: {orderInfo?.tracking?.hold_info?.operator || 'N/A' }</div>
            <div style={{marginBottom: 20}}>{t('notes')}: {orderInfo?.tracking?.hold_info?.notes || 'N/A' }</div>
        </UniDialog>
    </DialogContent>
          </Dialog>
    <FullscreenLoading open={fullScreenLoading()}/>
      </>
  );

    function complainToText(id) {
        return complainReasonList.filter((reason) => {
            return reason.id === id;
        })[0]
    }

    async function handleSaveNewComplain() {
        try {
            setIsFullScreenLoading(true);
            await dispatch(createCustomerComplain({
                tno: orderInfo.orders.tno,
                fresh_desk_ticket: freshdeskId,
                complain_reason_id: complaintContent,
                notes: complaintNote
            }))
            await dispatch(operationLog(orderId, userPref.username, 0, 1, 'CREATE_COMPLAINT', operationMemo))
            await dispatch(getOrderInfo(orderInfo?.orders?.tno, 'tno'));
            await dispatch(getCustomerComplain(orderInfo?.orders?.tno));
            await dispatch(showAlertSnackbar({ message: t('create_success'), type: 'success' }));
            setOpenComplaintDialog(false);
        } catch {
            dispatch(showAlertSnackbar({ message: t('create_fail'), type: 'error' }))
        } finally {
            setIsFullScreenLoading(false);
        }
    }

    function handleCopy() {
        navigator.clipboard.writeText(orderInfo.orders.address);
        dispatch(showAlertSnackbar({ title: 'Copy', message: t('common:copy_success'), type: 'success' }))
    }

    function paramsObjectTransfer(params) {
        return {
            order_id: orderInfo?.orders?.order_id,
            original_address: params.address,
            original_postal_code: params.postal_code || params.zipcode,
            is_invalid_address: false,
            format_address: params.new_address,
            postal_code_short: params.new_postal_code,
            lat: params.lat,
            lng: params.lng,
            city: params.locality,
            unit_number: params.unit_no,
            street_number: params.street_number,
            route_short: params.route,
            neighborhood_short: null,
            locality_short: params.locality,
            administrative_level_1_short: params.area_level_1,
            country_short: params.country,
            is_apt: params.is_apt,
            buzz_code: params.buzz_code,
            addr_type: params.addr_type
        }
    }

    function handleUpdateCloseSingle(addressModify) {
        let paramsAddresses = [];
        paramsAddresses.push(paramsObjectTransfer(addressModify));
        let params = {
            addresses: paramsAddresses,
            batch_list: orderInfo.orders.referer,
            warehouse: userPref.userCity,
            driver_id: orderInfo?.orders?.shipping_staff_id || getBranchById(userPref.userCity, branchList).wrong_address_collector,
            update_order_only: addressModify.update_order_only ? 1 : 0
        }
        setIsFullScreenLoading(true);
        dispatch(batchCorrectServiceWrongAddress(params))
        .then(() => {
            setOpenWrongAddressDialog(false);
            dispatch(operationLog(orderId, userPref.username, 0, 1, 'EDIT_DESTINATION', operationMemo))
            dispatch(getOrderInfo(orderInfo?.orders?.tno, 'tno'));
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('update_addr_fail'), type: 'error'}))
        })
        .finally(() => {
            setIsFullScreenLoading(false);
        })
    }

  function handleIsReadOnly() {
    return isUserReadOnly || isOrderReadOnly;
  }

    async function handleSignatureSwitchValue() {
        setIsFullScreenLoading(true);
        try {
            await dispatch(updateSignatureRequiredInfo(orderInfo?.orders?.tno, signature));
            await dispatch(operationLog(orderId, userPref.username, 0, 1, `EDIT_SIGNATURE_REQUIRED_SERVICE_TO ${signature}`, operationMemo));
            await dispatch(getOrderInfo(orderInfo?.orders?.tno, 'tno'));
        } catch (err) {
            setSignature(signatureOrigin || false);
            dispatch(showAlertSnackbar({ message: t('signature_service_failed'), type: 'error' }));
        } finally {
            setIsFullScreenLoading(false);
        }
    }

    async function handleFailedReasonSwitchValue() {
        setIsFullScreenLoading(true);
        try {
            await dispatch(updateFailedReason(orderInfo.orders.order_id, failedReason, userPref.userCity));

            await dispatch(operationLog(orderId, userPref.username, 0, 1, 'EDIT_FAILED_REASON_SERVICE', operationMemo));
            await dispatch(getOrderInfo(orderInfo?.orders?.tno, 'tno'));
        } catch (err) {
            setFailedReason(failedReasonOrigin || 0);
            dispatch(showAlertSnackbar({ message: t('failed_reason_service_failed'), type: 'error' }));
        } finally {
            setIsFullScreenLoading(false);
        }
    }

  async function handleRetrySwitchValue() { 
    setIsFullScreenLoading(true);
    try {
        await dispatch(switchRetry(orderInfo?.orders?.tno, retrySwitchValue));
        await dispatch(operationLog(orderId, userPref.username, 0, 1, 'EDIT_RETRY_SERVICE', operationMemo));
        await dispatch(getOrderInfo(orderInfo?.orders?.tno, 'tno'));
    } catch(err) {
        dispatch(showAlertSnackbar({message: t('retry_service_failed'), type: 'error'}));
    } finally {
        setIsFullScreenLoading(false);
    }
  }

  function fullScreenLoading(){
    if(isFullScreenLoading || isOrderUpdateLoading || isUpdateScanStatusLoading || isUpdateShippingStatusLoading || createSecondDeliveryLoading){
        return true
    } else {
        return false
    }
  }

  function updateRecordOrderUpdates(value){
      let updated = [...recordOrderUpdates]
      updated.push(value)
      setRecordOrderUpdates(updated)
  }

  /**
   * Open second delievry order info
   */
    function handleOpenEditOrder(tno) {
        handleSearch(tno, 'order_sn', 'tno');
    }

  /**
   * init
   */
  function init() {
    setCurrentFieldName(null);
    setCurrentFieldValue(null);
    setSearchType("tno");   //默认为Ant Parcel订单号；

    setOrderRouteHistoryList([]);
    setOrderOperationHistoryList([]);

    setSearchSN("");
    setSearchSNCurr("");
    setIsShowHistory(false);
    setHistorySearchSNList([]);

    //used for order info
    setStorageInfo("");
    setCallTime(null);
    setSmsTime(null);
    setContactTimes("");
    setOrderId("");
    setUnitSN("");
    setParcelSN("");
    setBatch("");
    setLinkedBatch("");
    setItemDesc("");
    setConsignee("");
    setMobile("");
    setAddress("");
    setUnit("");
    setPostcode("");
    setBuzzCode("");

    setLat("");
    setLng("");
    setDriver("");
    setDriverPhone("");
    setDriverMemo("");
    setOrderMemo("");
    setWarehouse("");
    setNewLocation("");
    setThrdPrtDeliverySN("");
    setScndryDlvryOrderSN("");
    setErroMsg("");
    setResendSN("");
    setShippingStatus("");

    setOperationMemo('');

    //used for show order detail all
    setIsShowDetailAll(false);

    //used for driver transfer
    setDriverTransfer("");
    setIsJumpInLine(0);

    // to prevent the contious post , once is submit , it need some time to resubmit
    setIsEditable(false);
    setIsScndryDeliverySubmitted(false);

    setIsInit(true);
  }

  /**
   * close the transshipment dialog
   */
  function handleTransClose(open) {
      setTransOpen(open);
  }

  /**
   * close the dialogue
   */
  function handleClose(){
    if(byResendOrder) {
        props.handleClose();
    }
    dispatch(handleEditOrderModal({open: false}))
  }

  /**
   * assemble order detail from orderInfo
   * @param {} orderInfo
   */
  function assembleOrderDetail(orderInfo) {
    setOrderId(orderInfo.order_id);
    setUnitSN(orderInfo.order_sn);
    setParcelSN(orderInfo.tno);
    setBatch(orderInfo.referer);
    setLinkedBatch(orderInfo.pin_label);
    setAddress(orderInfo.address);
    setUnit(orderInfo.sign_building);
    setBuzzCode(orderInfo.buzz_code);
    setLat(orderInfo.lat);
    setLng(orderInfo.lng);
    setDriver(orderInfo.shipping_staff_id);
    setDriverPhone(orderInfo.driver_phone) ;
    setDriverMemo(orderInfo.driver_notes);
  }

  /**
   * assemble order detail from trackingInfo
   * @param {} orderInfo
   */
  function assembleOrderTracking(trackingInfo) {
    setStorageInfo(trackingInfo.storage_info);
    setItemDesc(trackingInfo.item_description);
    setConsignee(trackingInfo.consignee);
    setMobile(trackingInfo.phone);
    setPostcode(trackingInfo.zip);
    setOrderMemo(trackingInfo.postscript);
    setWarehouse(trackingInfo.warehouse);
    warehouseList.forEach((item,index)=>{
        if (item.id === trackingInfo.warehouse) {
            setNewLocation(item.name);
        }
    });

    //setThrdPrtDeliverySN = orderInfo.;
    setScndryDlvryOrderSN(trackingInfo.second_delivery_sn);
    if (exceptionList !== null && trackingInfo.exception !== null) {
        exceptionList.forEach(element => {
            if (element.id === trackingInfo.exception )
                setErroMsg(element.en_message);
        });
    }
    setResendSN(trackingInfo.resend_req_no);
  }

  /**
   * assemble order detail from callLog
   * @param {} orderInfo
   */
  function assembleOrderCallLog(callLog) {
    setCallTime(callLog.call_time);
    setSmsTime(callLog.msg_time);
    setContactTimes(callLog.retries);
  }

  /**
   * post to the backend when the "Enter" key was pressed
   * 1. set the search SN
   * 2. save the search SN to local Storage
   * @param {*} e
   */
  function handleKeyUp(e) {
    if(e.keyCode === 13) {
        // get the value and reset the input field
        let searchSN = e.target.value;

        setSearchSN(searchSN);
    }
  }

    //  Verify if operator is Customer Service
    function verifyRole() {
        let roles = userInfo.roles;
        return roles.find(element => element === CUSTOMER_SERVICE || element === SENIOR_CUSTOMER_SERVICE) ? true : false;
    }

    //  Verify if order status is 213
    function verifyState(path) {
        let inStorage = false;
        if(path) {
            if(path.length > 0) {
                if(path[path.length - 1].code === 213) {
                    inStorage = true;
                }
            }
        }
        return inStorage;
    }

    // Only when operator is customer and order in storage will log "SEARCH_ORDER"
    function verifySearchOperationLog(path) {
        return verifyState(path) && verifyRole();
    }

    async function searchOrder(tno, type, typeFallback) {
        try {
            setSearchType(type);
            setIsFullScreenLoading(true);
            let res = await dispatch(getOrderInfo(tno, type));
            await dispatch(getCustomerComplain(res.orders.tno)).catch(() => { })
            if(res?.tracking?.hold_info?.blocking_batch) {
                setAlertOpen(true);
            }
            if(verifySearchOperationLog(res.path)) {
                await dispatch(operationLog(res.orders.order_id, userPref.username, 0, 1, 'SEARCH_ORDER', ''))
            }
            let response = await dispatch(getDriverScanRecord(res.orders.order_id));
            setDriverDispatches(response);
        } catch(err) {
            if(typeFallback) {
                searchOrder(tno, typeFallback);
                return;
            }
            if (err instanceof String) {
                dispatch(showAlertSnackbar({message: err, error: 'type'}));
            } else {
                dispatch(showAlertSnackbar({message: err.message || t('fail_message'), error: 'type'}));
            }
        } finally {
            setIsFullScreenLoading(false);
        }
    }

  /**
   * for trigger the validation action
   * show the detail info if the input is invaild
   */
  function handleSearch(tno, type) {
    //todo: post the fetch request to the backend
    if(tno && type) {
        setSearchSN(tno);
        searchOrder(tno, 'order_sn', 'tno');
    } else {
        if (searchSN !== undefined && searchSN !== null && searchSN !== "") {
            if(searchType=='storage_info'){
//  add search by storage code.
                searchOrder(localStorage.getItem('user_city')+'-'+searchSN, searchType);
            } else {
                searchOrder(searchSN, searchType);
            }
        }
    }
  }

  /**
   * clear the input field
   */
  function handleRest() {
    init();
  }

  /**
   * get the history search SN from the local storage if exist
   */
  function getSearchSNFromLocal() {
    return JSON.parse(localStorage.getItem("order_search_history") || '[]');
  }

  /**
   * save search SN to the local storage
   * format {"searchSN type driver phone",}
   */
  function saveSearchSNToLocal(orderInfo) {
    let orderObj = {
        order_id: orderInfo.order_id,
        order_sn: orderInfo.order_sn,
        tracking_number: orderInfo.tno,
        consignee: orderInfo.consignee,
        consignee_mobile: orderInfo.mobile,
        search_time: moment().unix(),
        shipping_staff_id: orderInfo.shipping_staff_id,
        driver_phone: orderInfo.driver_phone
    }

    let lsHistory = getSearchSNFromLocal()
    if(lsHistory.length > 0){
        let orderExistIndex = _.findIndex(lsHistory, ['order_id', orderInfo.order_id])
        if(orderExistIndex !== -1){
            _.remove(lsHistory, (o)=> o.order_id === orderInfo.order_id)
        }
        if(lsHistory.length >= 20){
            lsHistory.shift()
        }
    }

    lsHistory.push(orderObj)

    localStorage.setItem("order_search_history", JSON.stringify(lsHistory))
  }


  /**
   * read the search SN from local storage
   * open the SearchSN history List, max length is 8
   */
  function handleToggleDrawer(open,event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

    if (isShowHistory !== open) {
        setIsShowHistory(open);
        setHistorySearchSNList(getSearchSNFromLocal());
    }

  }

  /**
   * control the SearchSN history List, max length is 8
   */
  function toggleDrawer(open,event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
    if (isShowHistory !== open) {
        setIsShowHistory(open)
    }
  }

  /**
   * deal with process when user choose the history Search SN
   * @param {} e
   */
  function handleHistorySearchSNChoose(orderId) {
    if (orderId) {
        searchOrder(orderId, 'order_id')
    }
  }

  /**
   * for admin debug usage
   * show all the fields which fetched from the backend
   */
  function handleShowOrderDetailAll() {
      dispatch(getOrderInfoDetail(orderId));
      setIsShowDetailAll(true);
  }

  /**
   * close the detail window
   */
  function handleCloseOrderDetailAll() {
    setIsShowDetailAll(false);
  }

  /**
   *
   * @param {*} fieldName
   */
  function handleFieldChange(e,fieldName) {
    //setting the current field which is changing
    setCurrentFieldName(fieldName);
    dispatch(openFieldChangeDialog(true));
  }

  /**
   * reset the currentFieldValue
   * close the Dialog
   */
  function handleCloseFieldChangeDialog() {
    setCurrentFieldValue("");
      setPackageWidth();
      setPackageLength();
      setPackageWidth();
      setPackageHeight();
      setPackageWeightUnit();
      setPackageSizeUnit();
    dispatch(openFieldChangeDialog(false));
  }

  /**
   * save the new value to the modify field
   */
  function handleSaveFieldChangeDialog() {
      let params = {};

      if (currentFieldName === "mobile") {
          setMobile(currentFieldValue);
          params.mobile = currentFieldValue;
      }

      if (currentFieldName === "address") {
        setAddress(currentFieldValue);
        params.address = currentFieldValue;
      }

      if (currentFieldName === "unit") {
        setUnit(currentFieldValue);
        params.sign_building = currentFieldValue;
      }

      if  (currentFieldName === "postcode") {
        setPostcode(currentFieldValue)
        params.zipcode = currentFieldValue;
      }


      if (currentFieldName === "buzzCode") {
        setBuzzCode(currentFieldValue)
        params.buzz_code = currentFieldValue;
      }

      if (currentFieldName === "lat") {
        setLat(currentFieldValue);
        params.lat = currentFieldValue;
      }

      if (currentFieldName === "lng") {
        setLng(currentFieldValue);
        params.lng = currentFieldValue;
      }

      if (currentFieldName === "driverMemo") {
        setDriverMemo(currentFieldValue);
        params.driver_notes = currentFieldValue;
      }

      if (currentFieldName === "orderMemo") {
        setOrderMemo(currentFieldValue);
        params.postscript = currentFieldValue
      }
      if (currentFieldName === "warehouse") {
        setWarehouse(currentFieldValue);
        params.warehouse = currentFieldValue;
      }
      if (currentFieldName === "thrdPrtDeliverySN") {
        setThrdPrtDeliverySN(currentFieldValue);
        params.shipper = currentFieldValue;
      }
      if (currentFieldName === "shippingStatus") {
        setShippingStatus(currentFieldValue);
        params.shipping_status = currentFieldValue;
      }
      if (currentFieldName === "packageWeight") {
          setPackageWeight(currentFieldValue);
          params.total_weight = currentFieldValue;
          params.weight_uom=packageWeightUnit;
      }
      if (currentFieldName === "packageSize") {
          params.length = packageLength;
          params.width = packageWidth;
          params.height = packageHeight;
          params.dimension_uom = packageSizeUnit;
      }

      dispatch(updateOrderInfo(orderId, params)).then(()=>{
        dispatch(operationLog(orderId, userPref.username, 0, 1, operationPair[currentFieldName], operationMemo))
        setOperationMemo('');
          //dispatch(getOrderInfo(orderId, 'order_id'))
          updateRecordOrderUpdates(true)
      })

  }

    function handleDestinationEditSubmit(){
        if (destinationEditObj.zipcode && !regexZipMatch(destinationEditObj.zipcode, userUS)) {
            dispatch(showAlertSnackbar({ message: t('wrongAddressTool:zip_regex'), type: 'error' }));
            return;
        }

        const autoLatLng = getUserPreference().autoLatLng;
        if(!latLngVerify(destinationEditObj)) {
            dispatch(showAlertSnackbar({message: t('common:lat_lng_invalid'), type: 'warning'}))
            return;
        }
        dispatch(updateOrderInfo(orderId, destinationEditObj)).then((data)=> {
            dispatch(operationLog(orderId, userPref.username, 0, 1, 'EDIT_DESTINATION', operationMemo))
            setOperationMemo('');
            if(autoLatLng && _.has(destinationEditObj, 'address')){
                dispatch(editOrderAddress(orderId, destinationEditObj.address, 1)).then(()=>{
                    //dispatch(getOrderInfo(orderId, 'order_id'))
                    updateRecordOrderUpdates(true)
                })
            } else {
                updateRecordOrderUpdates(true)
                //dispatch(getOrderInfo(orderId, 'order_id'))
            }
        })
    }

  /**
   *  validation check , if pass the submit
   */
  function handleEditFieldSubmit() {

  }

  /**
   * submit the driver transfer request
   */
  async function handleSubmitDriverTransferDialog() {
    try {
        if (driverTransfer === undefined || driverTransfer === null) {
            dispatch(showAlertSnackbar({title: "Transfer Order", message: "Driver ID must not be empty"}));
            return
        }
        setIsFullScreenLoading(true);
        if(isJumpInLine) {
            await dispatch(orderJumpInLineTransferToDriver(orderInfo.orders.tno, driverTransfer));
        } else {
            let paramsAssign = {
                orders: [orderId],
                to_driver: driverTransfer,
                from_driver: driver,
                operator: userPref.username
            }
            await dispatch(assignOrderToDriver(paramsAssign));
        }
        dispatch(operationLog(orderId, userPref.username, 0, 4, 'TRANSFER_DRIVER', operationMemo))
        if(isJumpInLine){
            await dispatch(orderJumpInLineAddToRoute(orderId, driverTransfer));
        }
        await updateRecordOrderUpdates(true);
        if (isJumpInLine) {
            driverMemoScroll.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    } catch(err) {
        dispatch(showAlertSnackbar({title: 'Transfer Order Failure', message: err.message}))
    } finally {
        setOperationMemo('');
        setIsFullScreenLoading(false);
        setDriverTransfer("");
        setIsJumpInLine(false);
    }    
  }

  /**
   * reset
   * close the driver transfer Dialog
   */
  function handleCloseDriverTransferDialog() {

    //reset the input params
    setDriverTransfer("");
    setIsJumpInLine(false);

    dispatch(openDriverTransferDialog(false));
  }

  /**
   * reset
   * close the Secondary Express Dialog
   */
  function handleCloseSecondaryDeliveryDialog() {
    setOpenSecondaryDeliveryDialog(false);
    //dispatch(openSecondaryDeliveryDialog(false));
  }

  /**
   * handle Driver Transfer
   */
    function handleDriverTransfer() {
      dispatch(openDriverTransferDialog(true));
    }

    function isAccordionEmpty(data) {
        if (data && data.length >= 0)
            return false
        else return true
    }

    function showOrderType(data) {
        switch (data) {
            case 0:
                return "Local delivery";
            case 1:
                return "GV B2C ";
            case 2:
                return "Local delivery";
            case 10:
                return "GV B2B";
            default:
                return "N/A";
        }
    }

    function showExpressType(data) {
        switch (data) {
            case 0:
                return "Normal";
            case 1:
                return "Express";
            default:
                return "N/A";
        }
    }

    function showTransportType(data) {
        switch (data) {
            case 1:
                return "By Sea";
            case 2:
                return "By Air";
            case 3:
                return "By Ground";
            default:
                return "N/A";
        }
    }

    function showPartnerName(partnerId, data, order) {
        if (!_.isNil(order.customer_name)) {
            return order.customer_name
        }
        return "N/A";
    }

    function displayTimeFrom199(path) {
        if (!_.isNil(path)) {
            let pathTransit = _.find(path, function (index) {
                if (index.code == 199) {
                    return true;
                }
            }, 0);
            if (!_.isNil(pathTransit) && !_.isNil(pathTransit.dateTime.localTime) && !_.isNil(pathTransit.dateTime.timezone)) {
                let stateTime = moment.unix(momentTimeZone.tz(pathTransit.dateTime.localTime, pathTransit.dateTime.timezone).unix());
                let currentTime = moment.unix(momentTimeZone().unix());
                let diff = currentTime.diff(stateTime, 'minutes');
                let showTime = " ";
                if (diff >= 60) {
                    let leftHours = Math.floor(diff / 60);
                    let minutes = diff % 60;
                    showTime = minutes + " Minute(s)";
                    if (leftHours >= 24) {
                        let days = Math.floor(leftHours / 24);
                        let hours = leftHours % 24;
                        showTime = days + " Day(s) " + hours + " Hour(s) " + showTime;
                    } else {
                        showTime = leftHours + " Hour(s) " + showTime;
                    }
                }else {
                    return "less than 1 hour";
                }
                return showTime;
            }
        }
        return "N/A";
    }

    function displaySignature(dispatchType) {
        if (!_.isNil(dispatchType)&&dispatchType!="") {
            let dispatchDetails = JSON.parse(dispatchType);
            if (!_.isNil(dispatchDetails)) {
                let signature = dispatchDetails['SG'];
                if (signature === 1) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false;
    }
}



EditOrderModal.defaultProps = {
    onClose: ()=>{}
}

